<template>
  <div class="order-bus">
    <svg class="icon" width="169.79" height="102.4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.79 102.4"><path d="M149 83.54c-3.32 0-6 4-6 9a11.78 11.78 0 0 0 1.57 6.07v2.93H149c3.32 0 6-4 6-9s-2.64-9-6-9z" fill="#292a33"/><ellipse cx="143.87" cy="92.56" rx="6.01" ry="9.01" fill="#292a33"/><path d="M96.27 84.38c-3.32 0-6 4-6 9a11.78 11.78 0 0 0 1.57 6.07v2.93h4.43c3.32 0 6-4 6-9s-2.68-9-6-9z" fill="#292a33"/><path d="M162.34 94.73H42.65V6.2a6.2 6.2 0 0 1 6.2-6.2h68.48c13 0 24.64 7.84 26.87 13.31l12.94 35 8.56 15c2.66 3.84 4.08 13.93 4.08 18.59v5.33a7.45 7.45 0 0 1-7.44 7.5z" fill="#ea5959"/><path d="M24.26 84.38c-3.32 0-6 4-6 9a11.78 11.78 0 0 0 1.57 6.07v2.93h4.43c3.32 0 6-4 6-9s-2.68-9-6-9z" fill="#292a33"/><path d="M103.15 95h-94a4.45 4.45 0 0 1-4.4-4.5V9.8A9.2 9.2 0 0 1 13.17.28h53c10.66 0 20.26 7.84 24.29 19.84l7.94 28.72 7.54 14.79c2.18 3.84 3.35 13.93 3.35 18.59v5.33c-.02 4.12-2.76 7.45-6.14 7.45z" fill="#ff6e6e"/><path d="M151.63 78.88s.55-7.43 11.57-9.35a2.22 2.22 0 0 1 2.45 2.92c-1.06 3.13-4.31 7.28-14.1 6.58m-27.82-.27s-.55-7.43-11.57-9.35a2.22 2.22 0 0 0-2.45 2.92c1.06 3.13 4.31 7.28 14.1 6.58" fill="#ebebe6"/><path d="M125.24 73.07l.83 2.47c1.22 3.62 4.62 5.09 8.44 5.08h7.74c3.79 0 7.15-1.44 8.39-5l.83-2.42a2 2 0 0 0-1.89-2.66l-22.43-.09a2 2 0 0 0-1.91 2.62z" fill="#292a33"/><circle cx="156.13" cy="76.04" r="1.51" fill="#fff"/><circle cx="160.31" cy="73.73" r="1.51" fill="#fff"/><circle cx="118.21" cy="76.04" r="1.51" fill="#fff"/><circle cx="114.03" cy="73.73" r="1.51" fill="#fff"/><ellipse cx="20.45" cy="93.39" rx="6.01" ry="9.01" fill="#292a33"/><ellipse cx="19.96" cy="93.39" rx="2.33" ry="3.5" fill="#ff6e6e"/><ellipse cx="92.46" cy="93.39" rx="6.01" ry="9.01" fill="#292a33"/><ellipse cx="91.97" cy="93.39" rx="2.33" ry="3.5" fill="#ff6e6e"/><path d="M92 22l7.59 23.77a1.6 1.6 0 0 0 1.49 1l50.92.3a1.6 1.6 0 0 0 1.49-2.2l-8.66-24.79a3.19 3.19 0 0 0-3-2L95 17.7a3.19 3.19 0 0 0-3 4.3z" fill="#292a33"/><path d="M2.91 11.17c.55-.18 55.58 0 55.58 0v35.64" fill="none" stroke="#fc9d9d" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.108"/><path d="M93.6 44l-7.3-24.73A1.88 1.88 0 0 0 84.52 18H69.46a1.88 1.88 0 0 0-1.88 1.88v24.71a1.87 1.87 0 0 0 1.86 1.88l22.38.06A1.87 1.87 0 0 0 93.6 44z" fill="#292a33"/><path fill="none" stroke="#ebebe6" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.108" d="M133.83 72.84h16.34m-11.77 2.31h10.89"/><path d="M.55 85.17h11.91s2.35-7.48 9.28-7.48 8.59 7.62 8.59 7.62h52.21s2.63-7.62 9.56-7.62 9.69 6.92 9.69 6.92h17" fill="none" stroke="#fc9d9d" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.108"/><rect x="99.71" y="70.35" width="5.26" height="2.49" rx="1.25" ry="1.25" fill="#ebebe6"/><rect x="67.71" y="50.35" width="8.33" height="2.49" rx="1.25" ry="1.25" fill="#292a33"/><rect x="154.32" y="39.79" width="7.2" height="8.86" rx="3.6" ry="3.6" fill="#ff6e6e"/><rect x="86.74" y="39.79" width="7.2" height="8.86" rx="3.6" ry="3.6" fill="#ea5959"/><path d="M22 25.22v13.09h19.08V25.22H22zm8.78 12.24h-8V26.07h8v11.38z" fill="#fc9d9d"/><path d="M17.16 29.12l4.84-3.9h9.5l-3.94 3.94zm28.78-.01l-4.86-3.9H31.6l3.94 3.94z" fill="#fc9d9d"/></svg>
    <Busline />
  </div>
</template>

<script>
import Busline from './Busline'

export default {
  name: 'OrderBus',
  components: {
    Busline
  }
}
</script>

<style lang="scss" scoped>
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(0px, 1px, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-1px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(0px, 0, 0);
  }
}

.icon {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 2;
  animation: shake 0.9s cubic-bezier(0.36, 0.07, 0.19, 0.97) both infinite;
  transform: translate3d(0, 0, 0);
}
</style>
